<mat-checkbox [formControl]="agbControl" color="primary">
  {{ 'agb-form.text.accept' | translate }}
  <a (click)="displayAgbDialog($event)">{{ 'agb-form.text.agb' | translate }}</a
  >*
</mat-checkbox>
